import React from "react";
import { Container, Box, Typography, Link } from "@mui/material";
import Banner from "../Banner";

const TermsConditionsPage = () => {
  return (
    <>
      <Banner />
    <Container maxWidth="md" sx={{ py: 5 ,pb: 8 }}>
      {/* Page header */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4">Terms &amp; Conditions</Typography>
      </Box>

      {/* Content */}
      <Box sx={{ "& > * + *": { mt: 3 } }}>
        <Typography>
          This document outlines the terms and conditions (“Agreement”) governing the use of the website, services, events, and activities provided by Plastindia Foundation (“the Organization”). By accessing or using any of Plastindia Foundation’s services, you (“the User”) agree to comply with and be bound by these terms. If you do not agree, you must discontinue your use of the Organization’s services and website.
        </Typography>

        <Typography variant="h6">Introduction</Typography>
        <Typography>
          Plastindia Foundation is a non-profit organization dedicated to promoting the growth, development, and sustainability of the plastics industry. The Foundation organizes events, exhibitions, research initiatives, and capacity-building activities to achieve its objectives. These terms govern all interactions between the User and Plastindia Foundation.
        </Typography>

        <Typography variant="h6">2. Acceptance of Terms</Typography>
        <Box component="ul" pl={2}>
          <li>
            By accessing the Organization’s website or engaging in any services provided by Plastindia Foundation, you acknowledge that you have read, understood, and agreed to these terms and any additional guidelines or policies referenced herein.
          </li>
          <li>To provide updates about our initiatives, events, and programs.</li>
        </Box>

        <Typography variant="h6">3. User Eligibility and Responsibilities</Typography>
        <Box component="ul" pl={2}>
          <li>Eligibility: Users must be 18 years or older to access the website or participate in events and services unless explicitly stated otherwise.</li>
          <li>Accurate Information: The User is responsible for ensuring that all information provided to Plastindia Foundation is accurate, complete, and up-to-date.</li>
          <li>Prohibited Activities: Users are prohibited from engaging in any activities that may:</li>
          <Box component="ul" pl={2}>
            <li>Violate any laws or regulations.</li>
            <li>Harm or interfere with the operations of Plastindia Foundation’s website or services.</li>
            <li>Exploit, misuse, or infringe upon the intellectual property or proprietary rights of Plastindia Foundation.</li>
          </Box>
        </Box>

        <Typography variant="h6">4. Services Provided</Typography>
        <Typography>
          Plastindia Foundation provides the following services:
        </Typography>
        <Box component="ul" pl={2}>
          <li>Organization of exhibitions, events, and seminars related to the plastics industry.</li>
          <li>Dissemination of research, studies, and publications aimed at advancing industry knowledge.</li>
          <li>Networking opportunities for stakeholders in the plastics industry.</li>
          <li>Educational and capacity-building programs.</li>
        </Box>
        <Typography>
          The Foundation may modify, suspend, or discontinue any service at its sole discretion and without prior notice.
        </Typography>

        <Typography variant="h6">5. Intellectual Property Rights</Typography>
        <Box component="ul" pl={2}>
          <li>All content, materials, and intellectual property available on Plastindia Foundation’s website, including logos, trademarks, text, images, and multimedia, are owned by Plastindia Foundation unless otherwise stated.</li>
          <li>Users are prohibited from copying, reproducing, distributing, or using any content for commercial purposes without prior written consent.</li>
        </Box>

        <Typography variant="h6">6. Use of the Website</Typography>
        <Box component="ul" pl={2}>
          <li>The User agrees to use Plastindia Foundation’s website solely for lawful purposes aligned with the Organization’s objectives.</li>
          <li>Unauthorized activities, such as hacking, data mining, or introducing harmful software, are strictly prohibited.</li>
        </Box>

        <Typography variant="h6">7. Third-Party Links and Services</Typography>
        <Typography>
          Plastindia Foundation’s website may contain links to third-party websites or services for informational purposes. The Foundation does not endorse or assume responsibility for the content or practices of such third parties. Users accessing third-party links do so at their own risk.
        </Typography>

        <Typography variant="h6">8. Limitation of Liability</Typography>
        <Box component="ul" pl={2}>
          <li>Plastindia Foundation shall not be held liable for any direct, indirect, incidental, or consequential damages arising out of the use or inability to use the website, services, or events.</li>
          <li>The Organization is not responsible for errors, omissions, or inaccuracies in the content provided on its website or promotional materials.</li>
          <li>Any technical issues that disrupt services will be addressed promptly; however, no guarantees are made regarding uninterrupted service.</li>
        </Box>

        <Typography variant="h6">9. Confidentiality and Data Protection</Typography>
        <Box component="ul" pl={2}>
          <li>Plastindia Foundation respects the privacy of its Users. The collection, use, and storage of personal data are governed by the Foundation’s Privacy Policy.</li>
          <li>Users agree not to disclose any confidential information obtained through their engagement with the Foundation unless required by law.</li>
        </Box>

        <Typography variant="h6">10. Event Participation</Typography>
        <Box component="ul" pl={2}>
          <li><strong>Registration:</strong> Users participating in events organized by Plastindia Foundation must register as per the guidelines provided.</li>
          <li><strong>Code of Conduct:</strong> Participants are expected to adhere to professional and ethical behavior during events.</li>
          <li><strong>Cancellations and Refunds:</strong> In case of cancellation of an event by Plastindia Foundation, registered participants will be notified, and refunds (if applicable) will be processed as per the stated policy.</li>
        </Box>

        <Typography variant="h6">11. Force Majeure</Typography>
        <Typography>
          Plastindia Foundation shall not be held liable for failure to perform any of its obligations due to events beyond its reasonable control, including but not limited to acts of God, natural disasters, strikes, governmental actions, or technical failures.
        </Typography>

        <Typography variant="h6">12. Indemnification</Typography>
        <Typography>
          Users agree to indemnify and hold harmless Plastindia Foundation from any claim, loss, or damage arising out of their breach of this Agreement or misuse of the website or services.
        </Typography>

        <Typography variant="h6">13. Governing Law and Jurisdiction</Typography>
        <Typography>
          This Agreement is governed by and construed in accordance with the laws of India. Any disputes arising under these terms shall be resolved in the courts of Mumbai, India.
        </Typography>

        <Typography variant="h6">14. Termination</Typography>
        <Typography>
          Plastindia Foundation reserves the right to terminate or restrict access to its website or services for Users who violate these terms or engage in prohibited activities.
        </Typography>

        <Typography variant="h6">15. Contact Information</Typography>
        <Typography>
          For any questions, concerns, or clarifications regarding these terms, please contact:<br />
          Plastindia Foundation<br />
          401, Landmark B, Suren Road,<br />
          Off Andheri Kurla Road, Andheri (East),<br />
          Mumbai – 400093, India<br />
          Email: <Link href="mailto:contact@plastindia.org">contact@plastindia.org</Link><br />
          Phone: +91 22 26832911/15
        </Typography>
      </Box>
    </Container>
    </>
  );
};

export default TermsConditionsPage;
